import VerticalOneColumn from './VerticalOneColumn';

export default VerticalOneColumn;
